import { defineComponent } from '@vue/composition-api';
import __vue_component__ from '../SdsIllustration/SdsIllustration.vue.js';
import __vue_component__$1 from '../SdsBrandImage/SdsBrandImage.vue.js';
import __vue_component__$2 from '../SdsButtonIcon/SdsButtonIcon.vue.js';
import __vue_component__$3 from '../SdsIcon/SdsIcon.vue.js';
import __vue_component__$4 from '../SdsButton/SdsButton.vue.js';
import __vue_component__$5 from '../SdsBadge/SdsBadge.vue.js';

var script = defineComponent({
    props: {
        isDismissable: {
            type: Boolean,
            required: false,
            default: true,
        },
        styling: {
            type: String,
            default: '',
        },
        hasIllustration: {
            type: Boolean,
            required: false,
            default: false,
        },
        illustrationName: {
            type: String,
            required: false,
            default: '',
        },
        brandIllustrationName: {
            type: String,
            required: false,
            default: '',
        },
        title: {
            type: String,
            required: false,
            default: '',
        },
        iconName: {
            type: String,
            required: false,
            default: '',
        },
        isIconThemed: {
            type: Boolean,
            required: false,
            default: false,
        },
        badgeText: {
            type: String,
            required: false,
            default: '',
        },
        buttonLabel: {
            type: String,
            required: false,
            default: '',
        },
    },
    setup: function (_props, _a) {
        var emit = _a.emit;
        var on = {
            click: function (event) { return emit('click:button', event); },
        };
        return {
            on: on,
        };
    },
    emits: ['dismiss', 'click:button'],
    components: {
        SdsIllustration: __vue_component__,
        SdsBrandImage: __vue_component__$1,
        SdsButtonIcon: __vue_component__$2,
        SdsIcon: __vue_component__$3,
        SdsButton: __vue_component__$4,
        SdsBadge: __vue_component__$5,
    },
});

export default script;
